import { Platform, Dimensions, ScaledSize } from 'react-native';
import Constants from 'expo-constants';
import * as Localization from 'expo-localization';
import { hasNotch } from './hasNotch';
const pjson = require('../../package.json');

export { hasNotch };

export const IS_IOS = Platform.OS === 'ios';
export const IS_WEB = Platform.OS === 'web';

const getVersion = () => {
  const expoConfig = Constants.expoConfig as any;
  return IS_WEB
    ? pjson.version
    : `${expoConfig.version}.${
        IS_IOS ? expoConfig.ios.buildNumber : expoConfig.android.versionCode
      }`;
};

const msp = (dim: ScaledSize, limit: number) => {
  return dim.scale * dim.width >= limit || dim.scale * dim.height >= limit;
};
export const isTablet = () => {
  const dim = Dimensions.get('screen');

  return (dim.scale < 2 && msp(dim, 1000)) || (dim.scale === 2 && msp(dim, 1900));
};

const CODE_PUSH_VERSION: string | null = null;

export const VERSION = !CODE_PUSH_VERSION ? getVersion() : CODE_PUSH_VERSION;

export const LANGUAGE_CODE = (IS_WEB
  ? window.navigator.language
  : (Localization as any).locale
).startsWith('ru')
  ? 'ru'
  : 'en'; //getLocales()[0].languageCode;

export const IS_ANDROID = Platform.OS === 'android';
export const IS_TABLET = isTablet();
export const IS_PHONE = !IS_TABLET && !IS_WEB;
export const HAS_NOTCH = !IS_WEB ? true : false;

export const EVENT_CLOSE_MODAL = 'EVENT_CLOSE_MODAL';
export const EVENT_ALL_MODALS_CLOSED = 'EVENT_ALL_MODALS_CLOSED';

export const QUICK_PASSWORD = 'quickPassword';

export const ERRORS = {
  EMAIL_IN_USE: 'auth/email-already-in-use',
  USER_NOT_FOUND: 'auth/user-not-found',
  INVALID_EMAIL: 'auth/invalid-email',
  CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
};
